import {
  signInUsernameRule,
  signInPasswordRule
} from "../utils/formRulesCheck";
import { performSignIn } from "../api/dataFactory";
import { mapActions, mapGetters } from "vuex";
// import router from "../plugins/router";

const authPortalSignInMixins = {
  metaInfo: {
    title: "1byone health Sign In"
  },
  props: {
    redirect: {
      type: String,
      default: "/"
    }
  },
  data() {
    return {
      signInUsernameRule,
      signInPasswordRule,
      isValid: true,
      username: "",
      password: "",
      performSignInPending: false,
      hasError: false,
      hasSucceed:false,
      signInSucceedMessage: "",
      signInErrorMessage: ""
     
    };
  },
  methods: {
    ...mapActions(["recordUserInfo", "deleteUserInfo"]),

    async performSignIn() {
      this.hasError = false;
      this.signInErrorMessage = "";
      if (this.$refs.signInForm.validate()) {
        this.performSignInPending = true;

        let signInFormData = this.buildSignInFormData();
        let signInResult = await performSignIn(signInFormData);
        
        // localStorage.setItem("signInResult",signInResult.data);
        this.handleSignInResult(signInResult);

        this.performSignInPending = false;
      }
    },

    buildSignInFormData() {
      let signInFormData = new FormData();
      signInFormData.append("username", this.email);
      signInFormData.append("password", this.password);
      return signInFormData;
    },

    handleSignInResult(signInResult) {
      //remove current userInfo regardless the login is succeed or fail
      this.deleteUserInfo();
      if (signInResult == undefined) {
        this.hasError = true;
        this.signInErrorMessage =
          "Encounter unexpected error, please try again in a few minutes";
      } else if (signInResult.resultCode == 101) {
        this.hasError = false;
        this.hasSucceed = true;
        this.signInSucceedMessage =
        " Hi,"+signInResult.data.username+",You have logged in successfully";
        sessionStorage.setItem("username",signInResult.data.username);
        sessionStorage.setItem("accessToken",signInResult.data.accessToken); 
        this.recordUserInfo(signInResult.data);
        
        setTimeout(function (){window.location.href="/"} , 3000);
      } else if (signInResult.resultCode == 300) {
        this.hasError = true;
        this.signInErrorMessage =
          "user name entered not null";
      }else if (signInResult.resultCode == 302) {
        this.hasError = true;
        this.signInErrorMessage =
          "This user name entered not found";
      }else if (signInResult.resultCode == 303) {
        this.hasError = true;
        this.signInErrorMessage =
          "Wrong password. Try agin or click Forgot password to reset it";
      }
      if (this.hasError) {
        this.$refs.signInForm.reset();
      }
    }
  },
  computed: {
    ...mapGetters({
      emailFromStore: "email"
    }),
    email: {
      get() {
        return this.username == "" ? this.emailFromStore : this.username;
      },
      set(value) {
        this.username = value;
      }
    }
  }
};

export default authPortalSignInMixins;
